module.exports = __webpack_public_path__ + "img/card-2.e35f25a2.png";